<style></style>
<template>
  <div id="voucherset">
    <div class="header flex-between">
      <div class="header-text">
        <h1>券号规则设置</h1>
      </div>

      <div>
        <el-button icon="el-icon-edit-outline" v-if="disabled" plain @click="updateCode">修改</el-button>
        <el-button icon="el-icon-edit-outline" v-if="disabled" plain @click="saveCode">保存</el-button>
      </div>
    </div>

    <el-card shadow="never">
      <div style="width: 30%">
        <el-form ref="form" :model="form" label-width="100px" size="small" :disabled="isDisabled">
          <el-form-item label="劵号流水长度">
            <el-input v-model="form.coupSNLen" 
            type="text" onkeyup="value=value.replace(/[^\d]/g,'')"
            
            ></el-input>
          </el-form-item>
          <el-form-item label="流水起始值">
            <el-input v-model="form.coupMinSN" type="text" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="劵号前缀">
            <el-input v-model="form.prefixCoupCode" type="text" onkeyup="value=value.replace(/[^A-Z0-9]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="随机位数">
            <el-input v-model="form.randomLen"  type="text" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getcpyNo } from '@/utils/auth'
import {codeQueryApi,codeUpdateApi} from '@/api/user'
export default {
  name: "centre",
  data() {
    return {
      isDisabled:true,
      form: {
        coupSNLen:"",
        coupMinSN:"",
        prefixCoupCode:"",
        randomLen:"",
      },
      disabled:false
    };
  },
  created(){
    this.searchList();
    let VoucherSet = JSON.parse(localStorage.getItem("VoucherSet"));
    if(VoucherSet.length>0){
      this.disabled=true;
    }
  },
  methods: {
   async searchList(){
      const {data:res} =await codeQueryApi({
        cpyNO:getcpyNo()
      })
      if(res !== null){
        this.form = res
      }
      // console.log(res)
    },
    updateCode(){
      this.isDisabled=false
    },
    saveCode(){
       codeUpdateApi({
         cpyNO:getcpyNo(),
        coupSNLen:this.form.coupSNLen,
        prefixCoupCode:this.form.prefixCoupCode,
        randomLen:this.form.randomLen,
        coupMinSN:this.form.coupMinSN
       }).then(res=>{
        if(res.success==true) return this.$message.success("修改成功!")
      })
      this.inputValue()
    },
    inputValue(){
      codeQueryApi().then(res=>{
        this.form=res.data
        // console.log(res)
      })
    }
  },
};
</script>
<style lang="scss" scoped>
#voucherset {
  // height: 1000px;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0;
}
</style>
